module.exports = __webpack_public_path__ + "img/Wp_2082.f94964d2.png";